import { render } from "./DynamicTextArea.vue?vue&type=template&id=5f5f8991&ts=true"
import script from "./DynamicTextArea.vue?vue&type=script&lang=ts"
export * from "./DynamicTextArea.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicTextArea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f5f8991"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f5f8991', __exports__)) {
    api.reload('5f5f8991', __exports__)
  }
  
  module.hot.accept("./DynamicTextArea.vue?vue&type=template&id=5f5f8991&ts=true", () => {
    api.rerender('5f5f8991', render)
  })

}


export default __exports__